import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AESSQLConnectionService, SQLConnection } from "../../services/AESSQLConnectionService";
import { Account, AESAccountService } from "../../services/AESAccountService";

@Component({
    selector: 'sqlconnectiondialog',
    templateUrl: 'sqlconnectiondialog.html',
    styleUrls: ['./sqlconnectiondialog.css']
})
export class SQLConnectionEditDialog {

    instance: any;
    editType: string = "Create";

    inProgress: boolean;
    error: string;
    accounts: Account[];

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<SQLConnectionEditDialog>, private connectionSearch:AESSQLConnectionService, private accountSearch: AESAccountService) {
        var inst = data.instance;
        if (inst != undefined) {
            this.instance = { ...inst };
            this.editType = "Edit";
        }
        else{
            this.instance = {};
        }

        if(this.instance.port == undefined){
            this.instance.port = 3306;
        }
        var me = this;
        this.inProgress = true;
        accountSearch.search(undefined, undefined, undefined, undefined, undefined, undefined)
        .subscribe(data => {
            me.accounts = data.data;
            if(me.accounts == undefined || me.accounts.length == 0){
                me.error = "Unable to load accounts, please try again later or contact an administrator.";
            }
            else{
                me.inProgress = false;
                if(me.instance.acctId == undefined){
                    me.instance.acctId = data.data[0].acctId;
                }
            }
        }, (err) => {
           me.error = "Unable to load accounts, please try again later or contact an administrator.";
        });
    }

    save() {
        var obs;
        this.error = "";
        if(this.instance.host == undefined || this.instance.host == ''){
            this.error = "A host is required";
            return;
        }
        if((this.instance.defaultDb == undefined || this.instance.defaultDb == '')){
            this.error = "A Database is required";
            return;
        }
        var me = this;

        if(this.editType == "Create"){
            obs = this.connectionSearch.create(this.instance);
        }
        else{
            obs = this.connectionSearch.edit(this.instance);
        }
        this.instance.connectionType = "SQL";
        this.inProgress = true;
        obs.subscribe(resp => {
            this.dialogRef.close("SUCCESS");
            me.inProgress = false;
        }, (err) => {
           console.log(err);
           me.error = err.error.message;
           if(me.error == "Internal Server Error"){
               me.error = "Server was unable to process your request";
           }
           me.inProgress = false;
        });
    }
}